import React from 'react';
import { Alert, Snackbar, Box, Typography, Button } from '@mui/material';
import { WifiOff, Refresh } from '@mui/icons-material';
import { useOffline } from 'src/hooks/useOffline';

const OfflineIndicator: React.FC = () => {
  const { isOffline } = useOffline();

  return (
    <Snackbar
      open={isOffline}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{ mt: 8 }}
    >
      <Alert
        severity="warning"
        icon={<WifiOff />}
        action={
          <Button
            color="inherit"
            size="small"
            startIcon={<Refresh />}
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        }
        sx={{ width: '100%' }}
      >
        <Box>
          <Typography variant="body2" fontWeight={600}>
            You're offline
          </Typography>
          <Typography variant="caption">
            Some features may not be available. Changes will sync when you're back online.
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default OfflineIndicator;

